export default "__VITE_ASSET__Ctsg7tuD__"